import React, { useEffect, useState } from "react";
import "./styles.css";
import Layout from "../Layout/Content";
import Logo from "../../../image/Logo.png";
import RegisterImg from "../../../image/register-img.png";
import { useLocation, useNavigate } from "react-router-dom";
import { ethers } from "ethers";
import { useAuth } from "../../context/auth";
import { toast } from "react-toastify";
import axios from "axios";
import {
  DeodAbi,
  DeodAddress,
  StakeAbi,
  StakeAddress,
  StakeAddressTwo,
  StakeV2Balance,
} from "../Abi/Content";
import { switchNetwork } from "../../../utils/switchNetwork";

// NEW

const Content = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [auth, setAuth] = useAuth();
  const [refferal, setRefferal] = useState("");
  const location = useLocation();
  const [totalDeodStack, setTotaldeodStack] = useState();

  useEffect(() => {
    if (auth?.user?.address && auth?.user?.token) {
      if (auth.user.role === 1) {
        navigate("/admin-stakeone");
      } else {
        navigate("/stake6");
      }
    }
  }, [auth, navigate]);

  const handleIsRegisterApi = async (address) => {
    try {
      const resp = await axios.post(`/api/user/checkAddress`, {
        accountAddress: address,
      });
      if (resp.status === 200) {
        if (resp?.data?.status === false) {
          toast.error(resp?.data?.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        if (resp?.data?.status === true) {
          const isAdmin = [
            "0x2aa5f670f789c7630ffddc80c6efecb2f06128ff",
            // "0x65c0cb0e58d0a45d294bc0d1c37ee8c714e1372d",
            "0xbe99181bcab37bc57d3d2c7156bb7e1b72aafba2"
          ];
          var role = isAdmin.indexOf(address) !== -1 ? 1 : 0;
          setAuth({
            ...auth,
            user: {
              address: address,
              referralAddress: refferal,
              role: role,
            },
          });
          localStorage.setItem(
            "auth",
            JSON.stringify({
              user: {
                address: address,
                referralAddress: refferal,
                role: role,
              },
            })
          );
          navigate("/register");
        }
      }
    } catch (error) {
      if (error.response.status === 400) {
        var err_400 = error?.response?.data?.message;
        toast.error(err_400);
      } else if (error.response.status === 401) {
        const err_401 = error?.response?.data?.message;
        toast.error(err_401);
      } else if (error.response.status === 404) {
        const err_404 = error?.response?.data?.message;
        toast.error(err_404);
      } else if (error.response.status === 500) {
        const err_500 = error?.response?.data?.message;
        toast.error(err_500);
      } else {
        console.log("Error in Register", error);
        toast.error("something went wrong");
      }
    }
  };

  const handleIsregister = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let provider;
      if (window.ethereum) {
        provider = window.ethereum;
      } else if (window.web3) {
        provider = window.web3.currentProvider;
      } else {
        window.alert("No ethereum browser !checkout metamask");
      }
      if (provider) {
        if (provider !== window.ethereum) {
          console.error(
            "Not window.ethereum.Do you have multiple wallets installed"
          );
        }
        await provider.request({
          method: "eth_requestAccounts",
        });
      }
      await switchNetwork('bsc');
      const newProvider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = newProvider.getSigner();
      const message = [
        "Welcome to the Decentrawood Lock!",
        "Please sign this message to verify your identity.",
        "Please sign in!",
      ].join("\n\n");
      await signer.signMessage(message);
      const currentaccount = await signer.getAddress();
      // const address = ('0x041dACfA636A7efb961c3E896157bFDbb45B0dF3').toLowerCase();
      const address = currentaccount.toLowerCase();
      await handleIsRegisterApi(address);
    } catch (error) {
      console.log("wallet loagin Error", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (location?.search) {
      const searchParams = new URLSearchParams(location.search);
      let referralValue = searchParams.get("referral");

      if (!referralValue && location.search.includes("=")) {
        referralValue = Array.from(searchParams.values())[0];
      }

      if (referralValue) {
        // Remove trailing slashes if any are present from the URL path.
        referralValue = referralValue.split("/")[0];
        console.log("Referral Address:", referralValue);
        setRefferal(referralValue.toLowerCase());
      }
    }
  }, [location?.search]);

  useEffect(() => {
    // const jsonRpcUrl = "https://polygon-rpc.com";
    // const provider = new ethers.providers.JsonRpcProvider(jsonRpcUrl);

    // const handleGetTotalDeodStack = async () => {
    //   try {
    //     const DeodContract = new ethers.Contract(
    //       DeodAddress,
    //       DeodAbi,
    //       provider
    //     );
    //     let totalstackBalance = await DeodContract.balanceOf(StakeV2Balance);
    //     totalstackBalance = parseFloat(totalstackBalance) / 10 ** 18;
    //     totalstackBalance = totalstackBalance.toFixed(2);
    //     setTotaldeodStack(totalstackBalance);
    //   } catch (error) {
    //     console.log("totalstack error", error);
    //   }
    // };

    const handleGetTotalDeodStack = async () => {
      try {
        const token = auth?.user?.token;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can adjust this as needed
        };
        const resp = await axios.get(`/api/totalStake`, {
          headers,
        });
        if (resp.status === 200) {
          if (resp?.data?.status === true) {
            console.log(
              "totalStakeAmount",
              resp?.data?.totalStakeAmount?.totalStakeAmount
            );
            setTotaldeodStack(resp?.data?.totalStakeAmount?.totalStakeAmount);
          }
        } else {
          toast.error("Error", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } catch (error) {
        if (error?.response?.status === 400) {
          var err_400 = error?.response?.data?.message;
          toast.error(err_400);
        } else if (error?.response?.status === 401) {
          const err_401 = error?.response?.data?.message;
          toast.error(err_401);
        } else if (error?.response?.status === 404) {
          const err_404 = error?.response?.data?.message;
          toast.error(err_404);
        } else if (error?.response?.status === 500) {
          const err_500 = error?.response?.data?.message;
          toast.error(err_500);
        } else {
          console.log("Error in Register", error);
          toast.error("something went wrong");
        }
      }
    };

    handleGetTotalDeodStack();
  }, []);

  return (
    <Layout>
      <div className="home-bg">
        <div className="centered-wrapper">
          <div className="register-box">
            <h2 className="text-white">
              Decentrawood <span className="cus-span">Stake</span>
            </h2>
            <div className="register-img-container">
              <img
                src={RegisterImg}
                className="img-fluid register-img"
                alt="register"
              />
            </div>
            <form onSubmit={handleIsregister}>
              <button className="register-btn" type="submit">
                Register Now
              </button>
            </form>
          </div>
        </div>
      </div>
      {/* <div style={{ position: "fixed", bottom: "28px", right: "28px", zIndex: 9999, display: "flex", flexDirection: "column", alignItems: "center", gap: "6px" }}>
        <span style={{
          background: "rgba(0,0,0,0.75)",
          color: "#fff",
          fontSize: "12px",
          padding: "4px 10px",
          borderRadius: "12px",
          whiteSpace: "nowrap",
          pointerEvents: "none",
        }}>
          Contact us on Telegram
        </span>
        <a
          href="https://t.me/LiamAlmeida420"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            background: "#29A9EB",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
            textDecoration: "none",
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="white">
            <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 17.3l-1.99 1.93c-.23.23-.42.42-.83.42z"/>
          </svg>
        </a>
      </div> */}
    </Layout>
  );
};

export default Content;
